import React, { useCallback } from "react";
import TextareaAutosize from "react-textarea-autosize";
import { makeStyles } from "tss-react/mui";
import { isMobileBrowser } from "../../../environment/utils";
import Icon from "../../../icons/components/Icon";
import { IconCloseCircle } from "../../../icons/svg";
const useStyles = makeStyles()((theme) => {
    return {
        inputContainer: {
            display: "flex",
            flexDirection: "column",
        },
        label: {
            // color: "#ccc",
            // ...withPixelLineHeight(theme.typography.bodyShortRegular),
            // marginBottom: 8,
            color: "#C2C2C2",
            display: "flex",
            fontWeight: 400,
            marginBottom: 4,
            "&.is-mobile": {
            // ...withPixelLineHeight(theme.typography.bodyShortRegularLarge)
            },
        },
        fieldContainer: {
            position: "relative",
            display: "flex",
        },
        input: {
            background: "white",
            // backgroundColor: '#3D3D3D',
            // background: '#3D3D3D',
            // color: '#FFF',
            // ...withPixelLineHeight(theme.typography.bodyShortRegular),
            // borderRadius: 6,
            lineHeight: "18px",
            resize: "none",
            width: "100%",
            height: "40px",
            boxSizing: "border-box",
            overflow: "hidden",
            border: "1px solid #666666",
            backgroundColor: "#141414",
            color: "#FFF",
            borderRadius: "6px",
            padding: "10px 16px",
            "&::placeholder": {
                color: "#ccc",
                // color: '#C2C2C2'
            },
            "&:focus": {
                outline: 0,
                // boxShadow: `0px 0px 0px 2px ${'#4687ED'}`
                boxShadow: `0px 0px 0px 2px #ccc`,
            },
            "&:disabled": {
                color: "red",
            },
            "&.is-mobile": {
                height: "48px",
                padding: "13px 16px",
                // ...withPixelLineHeight(theme.typography.bodyShortRegularLarge)
            },
            "&.icon-input": {
                paddingLeft: "46px",
            },
            "&.error": {
                // boxShadow: `0px 0px 0px 2px ${'#F24D5F'}`
                boxShadow: `0px 0px 0px 2px red`,
            },
        },
        "input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0,
        },
        "input[type=number]": {
            "-moz-appearance": "textfield",
        },
        icon: {
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            left: "16px",
        },
        iconClickable: {
            cursor: "pointer",
        },
        clearableInput: {
            paddingRight: "46px",
        },
        clearButton: {
            position: "absolute",
            right: "16px",
            top: "10px",
            cursor: "pointer",
            // backgroundColor: "transparent",
            backgroundColor: "#ccc",
            border: 0,
            padding: 0,
        },
        bottomLabel: {
            marginTop: 8,
            // ...withPixelLineHeight(theme.typography.labelRegular),
            // color: '#C2C2C2',
            color: "#ccc",
            "&.is-mobile": {
            // ...withPixelLineHeight(theme.typography.bodyShortRegular)
            },
            "&.error": {
                // color: '#F24D5F'
                color: "red",
            },
        },
    };
});
const Input = React.forwardRef(({ accessibilityLabel, autoComplete, autoFocus, bottomLabel, className, clearable = false, disabled, error, icon, iconClick, id, label, maxValue, maxLength, maxRows, minValue, minRows, mode, name, onBlur, onChange, onFocus, onKeyPress, placeholder, readOnly = false, required, testId, textarea = false, type = "text", value, }, ref) => {
    const { classes: styles, cx } = useStyles();
    const isMobile = isMobileBrowser();
    const handleChange = useCallback((e) => onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value), []);
    const clearInput = useCallback(() => onChange === null || onChange === void 0 ? void 0 : onChange(""), []);
    return (React.createElement("div", { className: cx(styles.inputContainer, className) },
        label && (React.createElement("label", { className: cx(styles.label, isMobile && "is-mobile"), htmlFor: id }, label)),
        React.createElement("div", { className: styles.fieldContainer },
            icon && (React.createElement(Icon, Object.assign({}, (iconClick ? { tabIndex: 0 } : {}), { className: cx(styles.icon, iconClick && styles.iconClickable), onClick: iconClick, size: 20, src: icon }))),
            textarea ? (React.createElement(TextareaAutosize, { "aria-label": accessibilityLabel, autoComplete: autoComplete, autoFocus: autoFocus, className: cx(styles.input, isMobile && "is-mobile", error && "error", clearable && styles.clearableInput, icon && "icon-input"), disabled: disabled, id: id, maxLength: maxLength, maxRows: maxRows, minRows: minRows, name: name, onChange: handleChange, onKeyPress: onKeyPress, placeholder: placeholder, readOnly: readOnly, ref: ref, required: required, value: value })) : (React.createElement("input", Object.assign({ "aria-describedby": bottomLabel ? `${id}-description` : undefined, "aria-label": accessibilityLabel, autoComplete: autoComplete, autoFocus: autoFocus, className: cx(styles.input, isMobile && "is-mobile", error && "error", clearable && styles.clearableInput, icon && "icon-input"), "data-testid": testId, disabled: disabled, id: id }, (mode ? { inputmode: mode } : {}), (type === "number" ? { max: maxValue } : {}), { maxLength: maxLength }, (type === "number" ? { min: minValue } : {}), { name: name, onBlur: onBlur, onChange: handleChange, onFocus: onFocus, onKeyPress: onKeyPress, placeholder: placeholder, readOnly: readOnly, ref: ref, required: required, type: type, value: value }))),
            clearable && !disabled && value !== "" && (React.createElement("button", { className: styles.clearButton },
                React.createElement(Icon, { onClick: clearInput, size: 20, src: IconCloseCircle })))),
        bottomLabel && (React.createElement("span", { className: cx(styles.bottomLabel, isMobile && "is-mobile", error && "error"), id: `${id}-description` }, bottomLabel))));
});
export default Input;
